import { Button, Modal } from '@payaca/ambrosia';
import MarkdownLabel from '@payaca/components/markdownLabel/MarkdownLabel';
import { FC, useMemo } from 'react';

type Props = {
  isOpen: boolean;
  termsMarkdown?: string;
  privacyMarkdown?: string;
  onAgree: () => void;
  isAgreeing: boolean;
};

const TermsAndPrivacyModal: FC<Props> = (props) => {
  const { isOpen, termsMarkdown, privacyMarkdown, onAgree, isAgreeing } = props;

  const title = useMemo(() => {
    if (privacyMarkdown && termsMarkdown) {
      return 'Our updated terms of business and privacy policy';
    } else if (privacyMarkdown) {
      return 'Our updated privacy policy';
    } else {
      return 'Our updated terms of business';
    }
  }, [privacyMarkdown, termsMarkdown]);

  return (
    <Modal isOpen={isOpen} title={title} size="md">
      <Modal.Body>
        <p>
          Please review the following and confirm you agree to continue using
          Payaca
        </p>

        {termsMarkdown && (
          <>
            <h4>Terms of business</h4>
            <div className="max-h-64 overflow-y-auto rounded border p-3">
              <MarkdownLabel markdown={termsMarkdown} />
            </div>
          </>
        )}

        {privacyMarkdown && (
          <>
            <h4>Privacy &amp; cookie policy</h4>
            <div className="max-h-64 overflow-y-auto rounded border p-3">
              <MarkdownLabel markdown={privacyMarkdown} />
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button onClick={onAgree} isProcessing={isAgreeing}>
            I agree
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndPrivacyModal;
